module.exports = __webpack_public_path__ + "public/Icons/24Managestaticcontent.svg?1af6ccb2";